import { Component } from '@angular/core';

@Component({
    selector: 'rax-location-home-page',
    templateUrl: './location-home-page.component.html',
})
export class LocationHomePage {}
